module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "C128"
  }, [_c('em', [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }, [_vm._v("Contents")])])]), _c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('p', {
    staticClass: "C144"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('a', {
    attrs: {
      "href": "#/html/05_INTRODUCTION__Who_Is_Robert_E__H#page_1"
    }
  }, [_vm._v("INTRODUCTION. Who Is Robert E. Howard?")])]), _vm._v(" "), _c('p', {
    staticClass: "C144"
  }, [_c('a', {
    attrs: {
      "href": "#/html/06_CHAPTER_ONE__Pioneering_Stories#page_5"
    }
  }, [_vm._v("CHAPTER ONE. Pioneering Stories: The Family of Robert E. Howard")])]), _vm._v(" "), _c('p', {
    staticClass: "C144"
  }, [_c('a', {
    attrs: {
      "href": "#/html/07_CHAPTER_TWO__From_Birth_to_Bagwe#page_16"
    }
  }, [_vm._v("CHAPTER TWO. From Birth to Bagwell")])]), _vm._v(" "), _c('p', {
    staticClass: "C144"
  }, [_c('span', {
    attrs: {
      "href": "#/html/08_CHAPTER_THREE__Cross_Cut_and_Bur#page_33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER THREE. Cross Cut and Burkett")])]), _vm._v(" "), _c('p', {
    staticClass: "C144"
  }, [_c('span', {
    attrs: {
      "href": "#/html/09_CHAPTER_FOUR__The_Birth_of_a_Wri#page_43",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER FOUR. The Birth of a Writer")])]), _vm._v(" "), _c('p', {
    staticClass: "C144"
  }, [_c('span', {
    attrs: {
      "href": "#/html/10_CHAPTER_FIVE__Tattlers_and_Yello#page_51",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER FIVE. "), _c('em', [_vm._v("Tattlers")]), _vm._v(" and "), _c('em', [_vm._v("Yellow Jackets")])])]), _vm._v(" "), _c('p', {
    staticClass: "C144"
  }, [_c('span', {
    attrs: {
      "href": "#/html/11_CHAPTER_SIX__Pulp_Fictioneer#page_64",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER SIX. Pulp Fictioneer")])]), _vm._v(" "), _c('p', {
    staticClass: "C144"
  }, [_c('span', {
    attrs: {
      "href": "#/html/12_CHAPTER_SEVEN__The_Other_Side_of#page_77",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER SEVEN. The Other Side of the Counter")])]), _vm._v(" "), _c('p', {
    staticClass: "C144"
  }, [_c('span', {
    attrs: {
      "href": "#/html/13_CHAPTER_EIGHT__A_New_Species_of#page_88",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER EIGHT. A New Species of Fantasy Fiction")])]), _vm._v(" "), _c('p', {
    staticClass: "C144"
  }, [_c('span', {
    attrs: {
      "href": "#/html/14_CHAPTER_NINE__Friends_and_Letter#page_96",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER NINE. Friends and Letters")])]), _vm._v(" "), _c('p', {
    staticClass: "C144"
  }, [_c('span', {
    attrs: {
      "href": "#/html/15_CHAPTER_TEN__Novalyne_Price#page_116",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER TEN. Novalyne Price")])]), _vm._v(" "), _c('p', {
    staticClass: "C144"
  }, [_c('span', {
    attrs: {
      "href": "#/html/16_CHAPTER_ELEVEN__Broken_on_the_Pl#page_130",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER ELEVEN. Broken on the Plowshare of Fate")])]), _vm._v(" "), _c('p', {
    staticClass: "C144"
  }, [_c('span', {
    attrs: {
      "href": "#/html/17_CHAPTER_TWELVE__The_Aftermath#page_138",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER TWELVE. The Aftermath")])]), _vm._v(" "), _c('p', {
    staticClass: "C144"
  }, [_c('span', {
    attrs: {
      "href": "#/html/18_CHAPTER_THIRTEEN__Writing_a_Lega#page_146",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER THIRTEEN. Writing a Legacy: Selected Stories")])]), _vm._v(" "), _c('p', {
    staticClass: "C145"
  }, [_c('span', {
    attrs: {
      "href": "#/html/19_CHAPTER_FOURTEEN__Full_Circle__T#page_171",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER FOURTEEN. Full Circle: The Publishing Journey of a Barbarian")])]), _vm._v(" "), _c('p', {
    staticClass: "C144"
  }, [_c('span', {
    attrs: {
      "href": "#/html/20_Afterword#page_192",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Afterword")])]), _vm._v(" "), _c('p', {
    staticClass: "C144"
  }, [_c('span', {
    attrs: {
      "href": "#/html/21_Acknowledgments#page_195",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "C144"
  }, [_c('span', {
    attrs: {
      "href": "#/html/22_Notes#page_197",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])]), _vm._v(" "), _c('p', {
    staticClass: "C144"
  }, [_c('span', {
    attrs: {
      "href": "#/html/23_Index#page_229",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ca3484f0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/html/04_Contents.vue
// module id = 69
// module chunks = 0